import React, { useState, useEffect } from 'react';

import { Dropdown, Button, Icon, Header } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import { FAQ_PAGE_TYPE } from 'components/modules/pages/constants';
import { useQuestionsContext } from 'components/modules/questions/context';
import { useFaqsPage } from 'components/modules/questions/hooks/useFaqsPage';

import { useFaqsPageTabContext } from '../../context';

import './FaqsPageGroupAssignment.scss';

export default function FaqsPageGroupAssignment() {
  const { faqPage } = useFaqsPageTabContext();
  const { groups: allGroups, showMessage } = useQuestionsContext();
  const {
    assignedGroups,
    availableGroups,
    groupOptions,
    loading,
    saving,
    fetchError,
    addGroup,
    removeGroup,
  } = useFaqsPage(faqPage?.id, allGroups, FAQ_PAGE_TYPE);

  const [selectedGroupId, setSelectedGroupId] = useState(null);

  useEffect(() => {
    if (fetchError) {
      showMessage(fetchError, 'error');
    }
  }, [fetchError, showMessage]);

  async function onAddGroup() {
    if (!selectedGroupId) return;
    try {
      await addGroup(selectedGroupId);
      setSelectedGroupId(null);
      showMessage('Group added to FAQs page', 'success');
    } catch (e) {
      showMessage('Failed to add group', 'error');
    }
  }

  async function onRemoveGroup(groupId) {
    try {
      await removeGroup(groupId);
      showMessage('Group removed from FAQs page', 'success');
    } catch (e) {
      showMessage('Failed to remove group', 'error');
    }
  }

  if (loading) {
    return (
      <div className="faqs-page-group-assignment loading">
        <Icon name="spinner" loading /> Loading groups...
      </div>
    );
  }

  return (
    <div className="faqs-page-group-assignment">
      <Header as="h4">Question groups on this page</Header>
      <p className="description">
        Select which question groups appear on your FAQs page. Questions from these groups will be
        displayed to customers.
      </p>

      {!_isEmpty(assignedGroups) && (
        <div className="assigned-groups">
          {assignedGroups.map((group) => {
            const questionCount = (group.questions || []).length;
            return (
              <div key={group.id} className="assigned-group">
                <span className="group-name">
                  {group.name} ({questionCount})
                </span>
                <Button
                  className="delete-red compact"
                  icon="remove"
                  onClick={() => onRemoveGroup(group.id)}
                  loading={saving}
                  disabled={saving}
                  title="Remove from FAQs page"
                />
              </div>
            );
          })}
        </div>
      )}

      {!_isEmpty(availableGroups) && (
        <div className="add-group-row">
          <Dropdown
            placeholder="Add a question group"
            fluid
            selection
            options={groupOptions}
            value={selectedGroupId}
            onChange={(e, { value }) => setSelectedGroupId(value)}
            disabled={saving}
            className="add-group-dropdown"
          />
          <Button
            className="secondary-navy"
            content="Add"
            onClick={onAddGroup}
            loading={saving}
            disabled={!selectedGroupId || saving}
          />
        </div>
      )}

      {_isEmpty(availableGroups) && !_isEmpty(assignedGroups) && (
        <p className="all-assigned">All question groups are assigned to this page.</p>
      )}
    </div>
  );
}
